export default [
    {
        path: '/tendero-vip/galeria',
        meta: { nombre: 'Galeria' },
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/galeria').then(m => m.default || m),

    }
]
